module.exports = __webpack_public_path__ + "f088588c0fce3d304cd2136ffd6d850b.svg";